// extracted by mini-css-extract-plugin
module.exports = {"badge":"PageStatusBadge_badge__LhjGU"};